import { createFileRoute } from '@tanstack/react-router';
import { creativeById, creativeReadiness, creativeSpecs } from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireCapability, requireCreativeAssetsSession } from '@/lib/route-guards';
import { CreativeAssetsView } from '@/screens/creative-assets';

// The page Claude links a person to for a creative's files (`upload_url` on
// `GET /creatives/{id}/readiness`). Signed out, the session guard sends them to sign in and back
// here; then the role must edit creatives, as on /creatives/new.
export const Route = createFileRoute('/creatives/$creativeId/assets')({
  beforeLoad: async (options) => {
    await requireCreativeAssetsSession(options);
    await requireCapability('creatives_edit')(options);
  },
  loader: ({ context, params }) => {
    warmBackground(context.queryClient, creativeReadiness(params.creativeId));
    return warm(context.queryClient, creativeById(params.creativeId), creativeSpecs(undefined));
  },
  component: Page,
});

function Page() {
  const { creativeId } = Route.useParams();
  return <CreativeAssetsView creativeId={creativeId} />;
}
